import { createAction } from "redux-actions";
import { PostActionSnackbarConstants } from "../constants/postActionSnackbar.constants";

export const clearSnackbar = createAction(
    PostActionSnackbarConstants.CLEAR_SNACKBAR
);



// WEBPACK FOOTER //
// ./src/actions/postActionSnackbar.actions.js